import {
	getInitialStateSubMenu,
	initialStateModal
} from 'components/dynamicTab'
import { ElementComponent } from 'components/dynamicTab/elementComponent'
import { Icon } from 'components/icon'
import { Input } from 'components/input'
import { ModalConfirm } from 'components/modal'
import { handleValid } from 'components/myOrganization'
import { SetUpInfoTab } from 'components/setUpInfoTab'
import { SubMenuTabItem } from 'components/subMenuTabItem'
import { Typography } from 'components/typography'
import { Icons, TabMyOrganizationItem, TypographyTypes } from 'interfaces'
import React, { FC, useEffect, useState } from 'react'
import { Controller, Path, useFieldArray, useWatch } from 'react-hook-form'
import { configGenaral } from 'utils'
import { ElementItemMenuProps } from './menuTabItem.type'

export const ElementItemMenu: FC<ElementItemMenuProps> = (
	props
): JSX.Element => {
	const {
		active,
		menuIndex,
		errors,
		control,
		fieldError,
		isValid,
		remove: removeMenu,
		register,
		setValue,
		watch,
		setErrorForm,
		setFieldError,
		saveData
	} = props

	const [modalProps, setModalProps] = useState(initialStateModal)

	const enabledLink = useWatch({
		control,
		name: `tabs.${active}.setup_menu.${menuIndex}.setup_card.link.enabled_link`
	})

	const enabledMenu = useWatch({
		control,
		name: `tabs.${active}.setup_menu.${menuIndex}.setup_card.menu.enabled_menu`
	})

	const { remove } = useFieldArray({
		control,
		name: `tabs.${active}.setup_menu.${menuIndex}.components`
	})
	const nameField = `tabs.${active}.setup_menu.${menuIndex}.sub_menus`

	const dataSubMenu = useWatch({
		control,
		name: nameField as Path<{
			tabs: TabMyOrganizationItem[]
		}>
	})

	const rules = {
		name: {
			required: {
				value: true,
				message: 'This field is required'
			}
		},
		url: {
			required: {
				value: enabledLink,
				message: 'Is required'
			},
			maxLength: {
				value: 512,
				message: 'URL too large. Maximum 512 characters.'
			},
			pattern: {
				value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/,
				message: 'Please enter a valid url'
			}
		}
	}
	const handleDelectExternalLink = (): void => {
		const routeLink = `tabs.${active}.setup_menu.${menuIndex}.setup_card.link`
		setValue(
			`${routeLink}.url` as Path<{
				tabs: TabMyOrganizationItem[]
			}>,
			''
		)
		setValue(
			`${routeLink}.enabled_link` as Path<{
				tabs: TabMyOrganizationItem[]
			}>,
			false
		)
		setModalProps(initialStateModal)
	}
	const handleDelectMenu = (): void => {
		const routeMenu = `tabs.${active}.setup_menu.${menuIndex}.setup_card.menu`
		setValue(
			nameField as Path<{
				tabs: TabMyOrganizationItem[]
			}>,
			[]
		)
		setValue(
			`${routeMenu}.enabled_menu` as Path<{
				tabs: TabMyOrganizationItem[]
			}>,
			false
		)
		setModalProps(initialStateModal)
	}

	const nameType = `tabs.${active}.setup_menu.${menuIndex}`
	const dataInfoData = watch()
	const linkInfo =
		watch(
			`${nameType}.setup_card.link.enabled_link` as Path<{
				tabs: TabMyOrganizationItem[]
			}>
		) ?? false
	const urlInfo =
		watch(
			`${nameType}.setup_card.link.url` as Path<{
				tabs: TabMyOrganizationItem[]
			}>
		) ?? ''
	const components =
		watch(
			`${nameType}.components` as Path<{
				tabs: TabMyOrganizationItem[]
			}>
		) ?? []

	const enabledMenus =
		watch(
			`${nameType}.setup_card.menu.enabled_menu` as Path<{
				tabs: TabMyOrganizationItem[]
			}>
		) ?? false
	const setUpMenu =
		watch(
			`${nameType}.sub_menus` as Path<{
				tabs: TabMyOrganizationItem[]
			}>
		) ?? []

	const validateMenuData = (): boolean => {
		if (linkInfo && !String(urlInfo).trim()) {
			return false
		}

		if (enabledMenus && Array.isArray(setUpMenu) && setUpMenu.length === 0) {
			return false
		}

		if (
			!linkInfo &&
			!enabledMenus &&
			Array.isArray(components) &&
			components.length === 0
		) {
			return false
		}

		return true
	}

	useEffect(() => {
		const isValidMenu = validateMenuData()

		// Clean up component errors if submenu is enabled (components should be ignored when submenu is active)
		if (enabledMenus) {
			const componentsPath = `-tabs.${active}.setup_menu.${menuIndex}.components-`
			const cleanedErrors = fieldError.filter(
				error => !error.includes(componentsPath)
			)
			if (cleanedErrors.length !== fieldError.length) {
				setFieldError(cleanedErrors)
				return // Exit early to avoid re-adding errors
			}
		}

		if (fieldError.includes(nameType) && isValidMenu) {
			handleValid(nameType, true, setFieldError)
		} else if (!fieldError.includes(nameType) && !isValidMenu) {
			handleValid(nameType, false, setFieldError)
		}
	}, [
		dataInfoData,
		linkInfo,
		urlInfo,
		components,
		enabledMenus,
		setUpMenu,
		isValid
	])

	const confirmChangeStateLink = (): void => {
		setModalProps({
			open: true,
			title: 'External Redirection will be deleted!',
			description:
				'By disabling the External Redirection it will be deleted, do you want to continue?',
			onConfirm: () => {
				handleDelectExternalLink()
			}
		})
	}

	const confirmChangeStateMenu = (): void => {
		setModalProps({
			open: true,
			title: 'Menu will be deleted!',
			description:
				'By disabling the menu all contents and menu customization will be deleted, do you want to continue?',
			onConfirm: () => {
				handleDelectMenu()
			}
		})
	}
	const confirmRevomeMenu = (): void => {
		setModalProps({
			open: true,
			title: 'Menu will be deleted! ',
			description:
				'By deleting the menu all contents and menu customization will be deleted, do you want to continue?',
			onConfirm: () => {
				const updatedErrors = fieldError
					.filter(error => !error.includes(nameType))
					.map(error => {
						return error.replace(/setup_menu\.(\d+)/, (_, num) => {
							const newIndex =
								parseInt(num, 10) > menuIndex ? parseInt(num, 10) - 1 : num
							return `setup_menu.${newIndex}`
						})
					})

				setFieldError(updatedErrors)
				handleValid(nameType, true, setFieldError)
				removeMenu(menuIndex)
			}
		})
	}

	const handleEnabledSubMenu = (value: boolean): void => {
		const maxOrder = Math.max(
			...(Array.isArray(dataSubMenu)
				? dataSubMenu.map(c => (c as TabMyOrganizationItem).section_order || 0)
				: []),
			0
		)

		remove()
		setValue(nameField as Path<{ tabs: TabMyOrganizationItem[] }>, [
			{
				...getInitialStateSubMenu,
				section_order: maxOrder + 1
			}
		])
		setValue(
			`tabs.${active}.setup_menu.${menuIndex}.setup_card.menu.enabled_menu`,
			value
		)
		// Clean up component-related errors
		const componentsPath = `-tabs.${active}.setup_menu.${menuIndex}.components-`
		const updatedErrors = fieldError.filter(
			error => !error.includes(componentsPath)
		)
		setFieldError(updatedErrors)
		setModalProps(initialStateModal)
	}
	const confirmHandleEnabledSubMenu = (value: boolean): void => {
		setModalProps({
			open: true,
			title: 'Components Will Be Deleted',
			description:
				'By enabling the Sub menu option all components will be deleted, do you want to continue?',
			onConfirm: () => {
				handleEnabledSubMenu(value)
			}
		})
	}
	const confirmHandleEnabledRediretion = (value: boolean): void => {
		setModalProps({
			open: true,
			title: 'Components Will Be Deleted',
			description:
				'By enabling the External Redirection option all components will be deleted, do you want to continue?',
			onConfirm: () => {
				remove()
				setValue(
					`tabs.${active}.setup_menu.${menuIndex}.setup_card.link.enabled_link`,
					value
				)
				setModalProps(initialStateModal)
			}
		})
	}

	return (
		<div className="my-4 p-4 rounded-lg bg-white border-[1px] border-blue-primary">
			<div
				className="px-4 pb-6 rounded-lg bg-white border-[1px] border-blue-primary"
				style={{ boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.1)' }}
			>
				<div className="w-full py-3 flex justify-between items-center">
					<Typography
						title={`Menu ${menuIndex + 1}`}
						fontLeading="22/27"
						type={TypographyTypes.h2}
						className="text-gray-16"
					/>
					<div
						aria-hidden="true"
						className="z-10 cursor-pointer flex items-center"
						onClick={confirmRevomeMenu}
					>
						<Icon
							src={Icons.delete}
							className="w-7 ml-3 text-gray-1 "
							fillPath
						/>
						<Typography
							title="Remove"
							fontLeading="12/12"
							type={TypographyTypes.h2}
							className="text-gray-1"
						/>
					</div>
				</div>

				<Input
					name={`tabs.${active}.setup_menu.${menuIndex}.name`}
					min={1}
					register={register}
					rules={rules.name}
					error={errors?.tabs?.[active]?.setup_menu?.[menuIndex]?.name}
					borderFull={false}
					inputClassName="rounded-lg border-[1px] border-gray-17"
					limit
					cantLimit={configGenaral.maxTabNumber}
					setValueInput={setValue}
					autoFocus
					watchValue={watch(`tabs.${active}.setup_menu.${menuIndex}.name`)}
				/>

				<div className="flex md:flex-row flex-col gap-2 mt-4">
					<div className="w-full">
						<Controller
							control={control}
							name={`tabs.${active}.setup_menu.${menuIndex}.setup_card.link.enabled_link`}
							render={({ field: { value, onChange } }) => (
								<SetUpInfoTab
									title="Set external URL:"
									subTitle="External Redirection"
									icon={Icons.portal}
									value={value}
									setValue={enabledUrl => {
										if (!enabledUrl) {
											confirmChangeStateLink()
										} else if (
											Array.isArray(components) &&
											components.length > 0
										) {
											confirmHandleEnabledRediretion(enabledUrl)
										} else {
											onChange(enabledUrl)
										}
									}}
									disabled={enabledMenu}
								/>
							)}
						/>
						{enabledLink && (
							<Controller
								control={control}
								name={`tabs.${active}.setup_menu.${menuIndex}.setup_card.link.url`}
								render={() => {
									return (
										<Input
											name={`tabs.${active}.setup_menu.${menuIndex}.setup_card.link.url`}
											register={register}
											rules={rules.url}
											error={
												errors?.tabs?.[active]?.setup_menu?.[menuIndex]
													?.setup_card?.link.url
											}
											borderFull={false}
											inputClassName="rounded-lg border-[1px] border-gray-17"
											autoFocus
										/>
									)
								}}
							/>
						)}
					</div>
					<div className="w-full">
						<Controller
							control={control}
							name={`tabs.${active}.setup_menu.${menuIndex}.setup_card.menu.enabled_menu`}
							render={({ field: { value } }) => (
								<SetUpInfoTab
									title="Add Navigation Options:"
									subTitle="Enable Sub Menu"
									icon={Icons.listNotBox}
									value={value}
									setValue={stateValue => {
										if (stateValue) {
											if (Array.isArray(components) && components.length > 0) {
												confirmHandleEnabledSubMenu(stateValue)
											} else {
												handleEnabledSubMenu(stateValue)
											}
										} else {
											confirmChangeStateMenu()
										}
									}}
									disabled={enabledLink}
								/>
							)}
						/>
					</div>
				</div>
			</div>
			{!enabledLink && !enabledMenu && (
				<div className="my-2 px-4 rounded-lg bg-white border-[1px] border-blue-primary">
					<ElementComponent
						name={`tabs.${active}.setup_menu.${menuIndex}.components`}
						active={active}
						nameCard={`Menu ${menuIndex + 1} Content`}
						register={register}
						errors={errors}
						setValue={setValue}
						watch={watch}
						control={control}
						saveData={saveData}
						setFieldError={setFieldError}
						setErrorForm={setErrorForm}
						isValid={isValid}
						fieldError={fieldError}
						resourceUpdated
					/>
				</div>
			)}
			{enabledMenu && (
				<SubMenuTabItem
					name={`tabs.${active}.setup_menu.${menuIndex}`}
					register={register}
					errors={errors}
					setValue={setValue}
					watch={watch}
					control={control}
					saveData={saveData}
					setFieldError={setFieldError}
					setErrorForm={setErrorForm}
					isValid={isValid}
					fieldError={fieldError}
				/>
			)}
			<ModalConfirm
				open={modalProps.open}
				setOpen={() => setModalProps(initialStateModal)}
				hasCancel
				buttonLabelCancel="Cancel"
				buttonLabel="Yes"
				flexButton="row"
				handleCancel={() => setModalProps(initialStateModal)}
				onClickConfirm={modalProps.onConfirm}
				icon={Icons.warningActive}
				title={modalProps.title}
				descripcion={modalProps.description}
				classNameButton="h-[32px] w-[151px] m-0 !py-0"
			/>
		</div>
	)
}
